export default {
  "content": "<path d=\"M11.813 3.719c0 1.329-2.155 2.406-4.813 2.406S2.187 5.048 2.187 3.719m9.626 0c0-1.33-2.155-2.406-4.813-2.406S2.187 2.39 2.187 3.719m9.626 0v6.562c0 1.33-2.155 2.406-4.813 2.406s-4.813-1.077-4.813-2.406V3.72m9.626 0v2.187M2.187 3.72v2.187m9.626 0v2.188C11.813 9.423 9.658 10.5 7 10.5S2.187 9.423 2.187 8.094V5.906m9.626 0c0 1.33-2.155 2.407-4.813 2.407S2.187 7.234 2.187 5.905\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "14",
    "viewBox": "0 0 14 14",
    "fill": "none"
  }
};